import { Box, Fade, Typography } from '@mui/material'
import React from 'react'

const About = () => {
  return (
    <Fade in={true} timeout={1000}>
      <Box
        height={'100%'}
        width={'90%'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
      >
        <Typography variant="h4" gutterBottom>
          Um curioso por natureza e desenvolvedor por paixão.
        </Typography>
        <Typography variant="body1">
          Acredito que cada desafio é uma oportunidade de aprender e criar algo melhor. Minha missão é transformar necessidades em soluções inteligentes, combinando eficiência, criatividade e dedicação.
        </Typography>
      </Box>
    </Fade>
  )
}

export default About
